export const GBtnProperties = {
    applyFilter: {
        btnName: 'Apply Filter',
        fontColor: 'var(--clr-white)',
        background: 'var(--clr-primary-dark)',
        border: '1px solid var(--clr-primary-dark)',
        width: '100%',
        fontWeight: '500',
        fontSize: '13px',
        height: '100%',
        borderRadius: '6px',
        marginleft: '0px',
        padding: '8px 16px',
        cursor: 'pointer',
        icon: 'pi pi-filter'
    },
    clearAll: {
        btnName: 'Clear All',
        fontColor: 'var(--clr-primary-dark)',
        background: 'var(--clr-white)',
        border: '0.063rem dotted var(--clr-primary-dark)',
        width: '100%',
        fontWeight: '500',
        fontSize: '13px',
        height: '100%',
        borderRadius: '6px',
        marginleft: '0px',
        padding: '8px 16px',
        cursor: 'pointer',
        icon: 'pi pi-refresh'
    },
    cancelBtn: {
        btnName: 'Cancel',
        fontColor: 'var(--clr-primary-dark)',
        background: 'var(--clr-white) !important',
        border: '1px solid var(--clr-primary-dark)',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer'
    },
    cancelStudent: {
        btnName: 'Cancel',
        fontColor: 'var(--clr-primary-dark)',
        background: 'var(--clr-white) !important',
        border: '1px solid var(--clr-primary-dark)',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer'
    },
    saveStudent: {
        btnName: 'Save',
        fontColor: 'var(--clr-white)',
        background: 'var(--clr-primary-dark)',
        border: 'unset',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer',
        icon: 'pi pi-check'
    },
    downloadStudent: {
        btnName: 'Download',
        fontColor: 'var(--clr-white)',
        background: 'var(--clr-primary-dark)',
        border: 'unset',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer'
    },
    approvedBtn: {
        btnName: 'Approve',
        fontColor: 'var(--clr-primary-dark)',
        background: 'var(--clr-white) !important',
        border: 'unset',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer'
    },
    sendEmail: {
        btnName: 'Send',
        fontColor: 'var(--clr-white)',
        background: 'var(--clr-primary-dark)',
        border: 'unset',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer'
    },
    publishDrive: {
        btnName: 'Publish',
        fontColor: 'var(--clr-white)',
        background: 'var(--clr-primary-dark)',
        border: 'unset',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer',
        icon: 'pi pi-angle-double-right'
    },
    saveDriveEligibility: {
        btnName: 'Save',
        fontColor: 'var(--clr-primary-dark)',
        background: 'var(--clr-white) !important',
        border: '1px solid var(--clr-primary-dark)',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer'
    },
    rePublishDrive: {
        btnName: 'Republish',
        fontColor: 'var(--clr-white)',
        background: 'var(--clr-primary-dark)',
        border: 'unset',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer',
        icon: 'pi pi-refresh'
    },
    undoOnHold: {
        btnName: 'Undo Onhold',
        fontColor: 'var(--clr-white)',
        background: 'var(--clr-primary-dark)',
        border: 'unset',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer'
    },
    onHoldDrive: {
        btnName: 'On Hold',
        fontColor: 'var(--clr-secondary)',
        background: 'var(--clr-white) !important',
        border: '0.063rem solid var(--clr-secondary)',
        width: '100%',
        fontWeight: '500',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer',
        icon: 'pi pi-pause'
    },
    endDrive: {
        btnName: 'End Drive',
        fontColor: 'var(--clr-disabled)',
        background: 'var(--clr-disabled-bg) !important',
        border: '0.063rem dotted var(--clr-disabled)',
        width: '100%',
        fontWeight: '500',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer',
        icon: 'pi pi-stop-circle'
    },
    emailTemplate: {
        btnName: 'Save',
        fontColor: 'var(--clr-white)',
        background: 'var(--clr-primary-dark)',
        border: 'unset',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer'
    },
    saveDrive: {
        btnName: 'Save',
        fontColor: 'var(--clr-white)',
        background: 'var(--clr-primary-dark)',
        border: 'unset',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer'
    },
    save: {
        btnName: 'Save',
        fontColor: 'var(--clr-white)',
        background: 'var(--clr-primary-dark)',
        border: 'unset',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer',
        icon: 'pi pi-check'
    },
    saveAndProceed: {
        btnName: 'Save and Proceed',
        fontColor: 'var(--clr-white)',
        background: 'var(--clr-primary-dark)',
        border: 'unset',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer',
        icon: 'pi pi-check'
    },
    saveEligibility: {
        btnName: 'Save',
        fontColor: 'var(--clr-white)',
        background: 'var(--clr-primary-dark)',
        border: 'unset',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer',
        icon: 'pi pi-check'
    },
    viewEligibileStudents: {
        btnName: 'View Eligible Students',
        fontColor: 'var(--clr-primary-dark)',
        background: 'var(--clr-primary-dark-light) !important',
        border: '0.063rem solid var(--clr-primary-dark)',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer',
        icon: 'pi pi-users'
    },
    addCriteria: {
        btnName: 'Add Criteria',
        fontColor: 'var(--clr-primary-dark)',
        background: 'transparent',
        border: 'unset',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '12px',
        height: '100%',
        cursor: 'pointer',
        icon: 'pi pi-plus'
    },
    refresh: {
        btnName: 'Refresh',
        fontColor: 'var(--clr-primary-dark)',
        background: 'var(--clr-primary-dark-light) !important',
        border: '0.063rem solid var(--clr-primary-dark)',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer',
        icon: 'pi pi-refresh'
    },
    confirm: {
        btnName: 'Confirm',
        fontColor: 'var(--clr-white)',
        background: 'var(--clr-primary-dark)',
        border: 'unset',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer',
        icon: 'pi pi-check-circle'
    },
    cancel: {
        btnName: 'Cancel',
        fontColor: 'var(--clr-primary-dark)',
        background: 'var(--clr-white) !important',
        border: '0.063rem solid var(--clr-primary-dark)',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer',
        icon: 'pi pi-times'
    },
    createRound: {
        btnName: 'Create Round',
        fontColor: 'var(--clr-white)',
        background: 'var(--clr-primary-dark)',
        border: 'unset',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer',
        icon: 'pi pi-plus-circle'
    },
    clearSelectionAll: {
        btnName: 'Clear Selection',
        fontColor: 'var(--clr-disabled)',
        border: 'unset',
        background: 'transparent',
        width: '110px',
        fontWeight: '600',
        fontSize: '12px',
        cursor: 'pointer',
    },
    clearSelectionEducation: {
        btnName: 'Clear Selection',
        fontColor: 'var(--clr-disabled)',
        border: 'unset',
        background: 'transparent',
        width: '110px',
        fontWeight: 'bold',
        fontSize: '11px',
        cursor: 'pointer',
        icon: 'pi pi-times'
    },
    addTemplate: {
        btnName: 'Add Template',
        fontColor: 'var(--clr-white)',
        background: 'var(--clr-primary-dark)',
        border: 'unset',
        width: '100%',
        fontWeight: '500',
        fontSize: '14px',
        height: '38px',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer',
        icon: 'pi pi-plus'
    },
    mapProgramme: {
        btnName: 'Map Programme',
        fontColor: 'var(--clr-white)',
        background: 'var(--clr-primary-dark)',
        border: 'unset',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer'
    },
    rejectBtn: {
        btnName: 'Reject',
        fontColor: 'var(--clr-disabled)',
        background: 'var(--clr-disabled-bg) !important',
        border: 'unset',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer'
    },
    upload: {
        btnName: 'Upload',
        fontColor: 'var(--clr-white)',
        background: 'var(--clr-primary-dark)',
        border: 'unset',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer'
    },
    configureProgrammesOffered: {
        btnName: 'Configure Programmes Offered',
        fontColor: 'var(--clr-primary-dark)',
        background: 'var(--clr-white) !important',
        border: '1px solid var(--clr-primary-dark)',
        width: 'max-content',
        fontWeight: 'bold',
        fontSize: '11px',
        height: '100%',
        borderRadius: '6px',
        marginleft: '0px',
        padding: '8px 16px',
        cursor: 'pointer',
        icon: 'pi pi-book'
    },
    delete: {
        btnName: 'Delete',
        fontColor: 'var(--clr-disabled)',
        background: 'var(--clr-disabled-bg) !important',
        border: '0.063rem solid var(--clr-disabled)',
        width: '100%',
        fontWeight: 'bold',
        fontSize: '14px',
        height: '100%',
        borderRadius: '4px',
        marginleft: '0px',
        padding: '10px',
        cursor: 'pointer',
        icon: 'pi pi-trash'
    }
}